import { render, staticRenderFns } from "./mytpp.vue?vue&type=template&id=c2fffaf8&scoped=true"
import script from "./mytpp.vue?vue&type=script&lang=js"
export * from "./mytpp.vue?vue&type=script&lang=js"
import style0 from "./mytpp.vue?vue&type=style&index=0&id=c2fffaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fffaf8",
  null
  
)

export default component.exports